import { render } from "./PlanStudentDetailsPage.vue?vue&type=template&id=2bb9a174&ts=true"
import script from "./PlanStudentDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PlanStudentDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__